

import { cotizacionApi } from "../../apis";
import { useGlobalValueStore } from "../../stores/globalValues";
import { useUsuariosStore } from "../../stores/usuarios/usuarios.store";
import Swal from "sweetalert2";






export const listadoTodasCotizacion = async({ page=0, termino='' }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);

        const { data } = await cotizacionApi.get('/all', { params });
        // useOpsStore.setState({ totalOps: data.total });
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}




export const listadoVentasGuardadas = async() => {
    try {
        const { data } = await cotizacionApi.get('/all/ventas');
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const generarOpDesdeCotizacion = async(body) => {
    try {
        const { data } = await cotizacionApi.post(`/opdesde/cotizacion`, body);
        const usuario = JSON.parse(JSON.stringify(data.data?.usuario));
        useGlobalValueStore.setState({ view: data.view || 'cliente' });
        useUsuariosStore.setState({ usuarioVenta: {...usuario, id: usuario._id} });
        Swal.fire('Exitoso', data.msg, 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}



export const generarOpDesdeVenta = async(body) => {
    try {
        const { data } = await cotizacionApi.post(`/opdesde/venta`, body);
        useGlobalValueStore.setState({ view: data.view });
        Swal.fire('Exitoso', data.msg, 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}



export const guardarVentaCarrito = async(items) => {
    try {
        const { data } = await cotizacionApi.post(`/guardar/venta`, items);
        Swal.fire('Exitoso', data.msg, 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}




export const eliminarCotizacion = async(id) => {
    try {
        await cotizacionApi.delete(`/delete/${id}`);
        Swal.fire('Exitoso', 'Cotización Eliminada', 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}











// export const startComprarOP = async( datos ) => {
//     try {
//         const formData = new FormData();
//         if(datos?.imgPago && typeof datos?.imgPago !== 'string') { formData.append('images', datos.imgPago); }
//         Object.entries(datos).forEach(([key, value]) => {
//             formData.append(key, value?.toString());
//         });

//         const { data } = await opsApi.post('new', formData);
//         Swal.fire(  
//             `Tu Op es: ${ data.data.op }`, 
//             `Todo trabajo se inicia con un abono de <b>50% del valor total</b> y el saldo a la entrega del mismo. No se hace devolución de dinero una vez iniciado el trabajo. No nos hacemos responsables por trabajos pasados <b>30 dias desde la fecha de solicitud.</b> en caso de correcciones, se validaran maximo al siguiente dia de la entrega. Los diseños realizados por nosotros no seran impresos sin antes ser <b>aprobados por el cliente, REVISE MUY BIEN LOS DISEÑOS, no nos hacemos responsables por errores de ortografia, redacción, alineación, diagramación, tamaño del texto, logos, numeros telefonicos, correos, direcciones, fuentes, colores y demas después de la APROBACIÓN E IMPRESIÓN.</b> Tenga en cuenta que los colores en pantalla tienden a variar en la impresión, <b>No</b> nos comprometemos a sacar colores ni tamaños exactos. Recuerde que según la disponibilidad de tiempo se programa una posible fecha de entrega  <b>por ende los trabajos para entrega inmediata o a domicilio tienen un costo adicional el cual se validara con su distribuidor autorizado o directamente con la empresa.</b>`, 
//             'success'
//         );
//         return true;

//     } catch (error) {
//         const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
//         Swal.fire('Error', errores, 'error');
//         return false;
//     }
// } 